interface FormatTierOptions {
  fee: number;
  index: number;
  isLast: boolean;
  maxPrice?: number;
  minPrice: number;
}

export const formatPriceRange = ({
  index,
  isLast,
  maxPrice,
  minPrice,
}: Omit<FormatTierOptions, 'fee'>): string => {
  if (index === 0) {
    return `Up to £${(maxPrice! + 1).toLocaleString()}`;
  }

  if (isLast || maxPrice === undefined) {
    return `£${minPrice.toLocaleString()} and over`;
  }

  return `£${minPrice.toLocaleString()} to £${maxPrice.toLocaleString()}`;
};

export const formatFee = (fee: number, freeLabel = 'Free'): string => {
  if (fee === 0) {
    return freeLabel;
  }

  return `£${fee.toLocaleString()}`;
};
